import React, { useEffect, useRef, useState } from 'react'

import img from 'assets/images/distributionPage/coin_stack.png'
import img1 from 'assets/images/distributionPage/Partners/stage-6.png'
import video from 'assets/images/distributionPage/Partners/stage6.mp4'
import classNames from 'classnames'
import { AnimatedForm, Button, Form, Video } from 'shared/components'
import { useIntersection, useWindowSize } from 'shared/hooks'
import { playVideo } from 'shared/utils'
import { detectDevice } from 'shared/utils/detectDevice'

import classes from './Cooperation.module.scss'
import { fields } from './form'
import { FormTypes } from 'models'

const formId = 'distribution-question-form'

export const Cooperation = (): JSX.Element => {
  const ref = useRef<HTMLVideoElement>(null)
  const [titleRef, titleRefEntry] = useIntersection({})
  const [isPlayed, setIsPlayed] = useState<boolean>(false)
  const [isFormOpened, setFormOpened] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const { isMobile } = useWindowSize()
  const isTabletDevice = detectDevice()

  useEffect(() => {
    if (titleRefEntry?.isIntersecting && !isPlayed) {
      setIsPlayed(true)
      playVideo(ref.current)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleRefEntry])

  const handleSubmit = () => {
    setIsSubmit(true)
  }

  const handleClose = () => {
    setIsSubmit(false)
    setFormOpened(false)
  }

  const renderTablet = () => (
    <img className={classes.tabletImg} src={img1} alt="" />
  )

  const cn = classNames([
    classes.container,
    'container reveal-from-bottom`',
    {
      [classes.offset]: isTabletDevice || isMobile,
    },
  ])
  return (
    <>
      <div className={cn} data-reveal-delay={50}>
        <h2 className={`${classes.title} second-title`}>
          <span ref={titleRef}>
            ХОТИТЕ ЗАРАБАТЫВАТЬ{'\n'}БОЛЬШЕ? ПРИГЛАШАЕМ{'\n'}К СОТРУДНИЧЕСТВУ
          </span>
          <Video
            videoRef={ref}
            className={classes.video}
            src={video}
            childTablet={renderTablet}
          />
        </h2>

        <p className={classes.descr}>
          Если Вы не обнаружили нужной информации,{'\n'}задайте вопрос, и мы
          ответим в ближайшее время
        </p>
        <Button
          style={{ position: 'relative' }}
          onClick={() => setFormOpened(true)}
        >
          Задать вопрос
        </Button>
        {isTabletDevice || isMobile ? null : (
          <img src={img} alt="" className={classes.img} />
        )}
      </div>

      <div className="container">
        <AnimatedForm
          id={formId}
          duration={400}
          open={isFormOpened}
          onCloseClick={() => handleClose()}
          scrollCenter={isSubmit}
        >
          <Form
            showed={isFormOpened}
            id={formId}
            fields={fields}
            title="Задать вопрос"
            formClasses={classes.form}
            showUserAgreement
            onCloseClick={() => handleClose()}
            onAutoClose={() => handleClose()}
            onSubmit={() => handleSubmit()}
            type={FormTypes.Distributive}
            titleLarge
          />
        </AnimatedForm>
      </div>
    </>
  )
}
